import 'owl.carousel';

var item_index = 0;
var item_count = 0;
var target_title = 0;
var target_index = 0;
var spacer = false;
const title = document.querySelector('.c-hero_slider__title');

const secondary_title = document.querySelector('.c-hero_slider__secondary');

function init() {

  const sliders = document.querySelectorAll('.c-hero_slider');

  if (!sliders) {
    return;
  }

  OwlCarousel1();
  // window.addEventListener('resize', resize_slider);

}

function OwlCarousel1() {

  $('.featured-carousel').owlCarousel({

    margin: 20,
    autoplay: false,
    items: 1,
    nav: true,
    navText : [$('.c-featured__left_arrow'),$('.c-featured__right_arrow')],
    dots: true

  });

}


export default init;
